<template>
  <div class="relative h-svh">
    <slot/>    
  </div>
</template>


<style>

</style>